<template>
    <Typography
        is="div"
        type="paragraph"
        size="xs"
    >
        <Link
            :to="{ name: ROUTE_NAMES.MAIN }"
            color="white-40"
        >
            {{ $tr('navigation.copyright', { year: String(new Date().getFullYear()) }) }}
        </Link>
    </Typography>
</template>

<script setup lang="ts">
import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES } from '@/router/constants'
</script>
